var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control lang-switch"},[_c('a',{staticClass:"lang fr",class:{active: _vm.language == 'fr'},on:{"click":function($event){_vm.change('fr')}}},[_vm._v("Fr")]),_c('div',{staticClass:"separator"}),_c('a',{staticClass:"lang en",class:{active: _vm.language == 'en'},on:{"click":function($event){_vm.change('en')}}},[_vm._v("En")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc6bdc4","hasScoped":true}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/controls/lang-switch.vue
// module id = 376
// module chunks = 0